/**
 * Modul Cart > Events
 */

import {
	needJquery, extend
} from '../../../../shared/utils';

import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator from "../../../../shared/dom/manipulator";

import Slider from "../../../../shared/components/slider/slider";
import {initTooltips} from "../../../vendors/bootstrap/bootstrap";

// ------
// Private
// ------

const CART_NAME = 'events';

const renderEventGroups = (group) => {
	const EVENT_LIST = SelectorEngine.findOne(`[data-ce="${CART_NAME}-list"]`);

	if(!EVENT_LIST) {
		return;
	}

	let _tplGroup       = `<div class="${CART_NAME}-group"/>`;
	let _tplGroupHeader = `<div class="group-header"/>`;
	let _tplGroupSlider = `<div class="${CART_NAME}-group"><div class="slider rs_preserve" data-c="slider-events-gallery"><div class="swiper slider-container"><div class="swiper-wrapper slider-items"></div></div></div></div>`;
	let _tplSliderItem  = `<div class="swiper-slide slider-item"><div class="slider-item__inner"></div></div>`;
	let _tplSwiperArrowPrev  = `<div class="swiper-button-prev rs_preserve button -primary -square"><span aria-hidden="true" class="button__label"><i class="far fa-arrow-left"></i></span></div>`;
	let _tplSwiperArrowNext  = `<div class="swiper-button-next rs_preserve button -primary -square"><span aria-hidden="true" class="button__label"><i class="far fa-arrow-right"></i></span></div>`;

	let _elGroup       = null;
	let _elGroupHeader = null;

	// EVENT_LIST.innerHTML = '';

	return;

	for (const property in group) {
		if(group[property].elements.length > 1) {
			_elGroup = Manipulator.createElementFrom(_tplGroupSlider);
			_elGroupHeader = Manipulator.createElementFrom(_tplGroupHeader);
			if(group[property].title) Manipulator.elementAppend(group[property].title, _elGroupHeader);
			if(group[property].organizer) Manipulator.elementAppend(group[property].organizer, _elGroupHeader);
			if(group[property].period) Manipulator.elementAppend(group[property].period, _elGroupHeader);
			if(group[property].badge) Manipulator.elementAppend(group[property].badge, _elGroupHeader);
			Manipulator.elementPrepend(_elGroupHeader, _elGroup);
			initTooltips(_elGroupHeader);
			Manipulator.addClass(_elGroup, '-slider');
		} else {
			_elGroup = Manipulator.createElementFrom(_tplGroup);
			// _elGroupHeader = Manipulator.createElementFrom(_tplGroupHeader);
			// if(group[property].title) Manipulator.elementAppend(group[property].title, _elGroupHeader);
			// if(group[property].organizer) Manipulator.elementAppend(group[property].organizer, _elGroupHeader);
			// if(group[property].period) Manipulator.elementAppend(group[property].period, _elGroupHeader);
			// if(group[property].badge) Manipulator.elementAppend(group[property].badge, _elGroupHeader);
			// Manipulator.elementPrepend(_elGroupHeader, _elGroup);
			// initTooltips(_elGroupHeader);
			Manipulator.addClass(_elGroup, '-single');
		}

		let slider = SelectorEngine.findOne('.slider', _elGroup);
		let _btnPrev = Manipulator.createElementFrom(_tplSwiperArrowPrev);
		let _btnNext = Manipulator.createElementFrom(_tplSwiperArrowNext);

		Manipulator.elementAppend(_btnPrev, slider);
		Manipulator.elementAppend(_btnNext, slider);

		for (const element of group[property].elements) {
			if (group[property].elements.length > 1) {
				let _elSliderItem = null;

				if(!slider) {
					continue;
				}

				_elSliderItem = Manipulator.createElementFrom(_tplSliderItem);

				Manipulator.elementAppend(element, SelectorEngine.findOne('.slider-item__inner', _elSliderItem));
				Manipulator.elementAppend(_elSliderItem, SelectorEngine.findOne('.swiper-wrapper', _elGroup));

				Slider.init(slider, {
					autoHeight   : false,
					slidesPerView: 'auto',
					spaceBetween : 0
				});
			}
			else {
				Manipulator.elementAppend(element, _elGroup);
			}
		}

		Manipulator.elementAppend(_elGroup, EVENT_LIST);
	}
};

const sortEventsIntoGroups = (collection) => {
	const GROUP = {};

	for (const ELEMENT of collection) {
		const ID  = parseInt(Manipulator.getDataAttribute(ELEMENT, `${CART_NAME}group`));
		let title = SelectorEngine.findOne('.card__body .title', ELEMENT);
		let badge = SelectorEngine.findOne('.card__header .badge-group', ELEMENT);
		let organizer = SelectorEngine.findOne('.card__body .organizer', ELEMENT);
		let period = SelectorEngine.findOne('.card__body .period', ELEMENT);

		if (!GROUP[ID]) {
			GROUP[ID] = {};

			GROUP[ID].title = title ? Manipulator.createElementFrom(title.outerHTML) : null;
			GROUP[ID].badge = badge ? Manipulator.createElementFrom(badge.outerHTML) : null;
			GROUP[ID].organizer = organizer ? Manipulator.createElementFrom(organizer.outerHTML) : null;
			GROUP[ID].period = period ? Manipulator.createElementFrom(period.outerHTML) : null;
			GROUP[ID].elements = [];
		}

		GROUP[ID].elements.push(ELEMENT);
	}

	return GROUP;
};

// ------
// Public
// ------

const init = () => {
	const COLLECTION = SelectorEngine.find(`[data-cart="${CART_NAME}"] [data-${CART_NAME}group]`);

	if (!COLLECTION.length) {
		return;
	}

	let _group = sortEventsIntoGroups(COLLECTION);

	if (Object.keys(_group).length === 0 && _group.constructor === Object) {
		return false;
	}

	renderEventGroups(_group);
};

// ------
// Export
// ------

export default {
	init: init
};